import { api } from '@/api'
import type { CreateCatalogRoleRequestBody, ProductStructureResponse, UpdateCatalogRoleRequestBody } from '@/api/access.types'
import type { ProductStructure, RoleInput } from '../types'
import { toCreateRequest, toProductStructure, toUpdateRequest } from '../transform/roleTransformer'

// The IDP catalog-structure + custom-role CRUD, reached through the BFF proxy.
// Products/catalog-roles reads are owned by features/users/api/accessApi.ts
// and reused from there (see hooks.ts) — this module only owns what the
// tier-matrix editor adds: the structure spine and role writes.
const PRODUCTS_BASE = '/v1/admin/catalog/products'
const CATALOG_ROLES_BASE = '/v1/admin/catalog/roles'

// GET /v1/admin/catalog/products/{product} → the domain/resource/verb spine
// and the generated viewer/editor/admin tiers the matrix renders against.
export function getProductStructure(product: string): Promise<ProductStructure> {
  return api.get<ProductStructureResponse>(`${PRODUCTS_BASE}/${product}`).then(toProductStructure)
}

// POST /v1/admin/catalog/roles.
export function createRole(product: string, input: RoleInput): Promise<void> {
  const body: CreateCatalogRoleRequestBody = toCreateRequest(product, input)
  return api.post(CATALOG_ROLES_BASE, { body }).then(() => undefined)
}

// PUT /v1/admin/catalog/roles/{product}/{roleId}.
export function updateRole(product: string, roleId: string, input: RoleInput): Promise<void> {
  const body: UpdateCatalogRoleRequestBody = toUpdateRequest(input)
  return api.put(`${CATALOG_ROLES_BASE}/${product}/${roleId}`, { body }).then(() => undefined)
}

// DELETE /v1/admin/catalog/roles/{product}/{roleId}.
export function deleteRole(product: string, roleId: string): Promise<void> {
  return api.delete(`${CATALOG_ROLES_BASE}/${product}/${roleId}`).then(() => undefined)
}
